import { Form, InputNumber, Select, Typography } from 'antd'
import { OPTIONAL_RENTAL_FEE_NOTICE } from '@super-mega/server/contracts/business'
import { REQUIRED_FIELD_RULES as required } from '@/const/form.ts'
import type { RentalFormValues } from './rental-form.types.ts'

export function RentalPriceFields() {
  const form = Form.useFormInstance<RentalFormValues>()
  const rentType = Form.useWatch('rentType', form)
  let rentUnitLabel = '月'
  if (rentType === 'daily') {
    rentUnitLabel = '日'
  } else if (rentType === 'yearly') {
    rentUnitLabel = '年'
  }
  return (
    <section
      className="border-border bg-surface scroll-mt-24 rounded-xl border p-5 shadow-xs"
      id="section-rental-price"
    >
      <div className="mb-5">
        <Typography.Title className="mb-1!" level={5}>
          协议价格
        </Typography.Title>
        <Typography.Text type="secondary">
          {OPTIONAL_RENTAL_FEE_NOTICE}管理费按租金的计价单位及出账周期收取，水电费按实际抄表核算。
        </Typography.Text>
      </div>
      <div className="grid gap-x-6 md:grid-cols-4">
        <Form.Item label="计价单位" name="rentType" rules={required}>
          <Select
            options={[
              { label: '按日', value: 'daily' },
              { label: '按月', value: 'monthly' },
              { label: '按年', value: 'yearly' }
            ]}
          />
        </Form.Item>
        <Form.Item label={`每几${rentUnitLabel}出账`} name="billingInterval" rules={required}>
          <InputNumber className="w-full!" min={1} precision={0} />
        </Form.Item>
        <Form.Item label="每单位协议价（元）" name="agreedPrice" rules={required}>
          <InputNumber className="w-full!" min={0} precision={2} prefix="¥" />
        </Form.Item>
        <Form.Item label="约定押金（元，可选）" name="depositAmount">
          <InputNumber className="w-full!" min={0} precision={2} prefix="¥" placeholder="留空不出账单" />
        </Form.Item>

        <Form.Item label={`管理费（元/${rentUnitLabel}，可选）`} name="managementFee">
          <InputNumber className="w-full!" min={0} precision={2} prefix="¥" placeholder="留空不出账单" />
        </Form.Item>
        <Form.Item label="水费（元/吨，可选）" name="waterUnitPrice">
          <InputNumber className="w-full!" min={0} precision={2} prefix="¥" placeholder="留空不出账单" />
        </Form.Item>
        <Form.Item label="电费（元/度，可选）" name="electricityUnitPrice">
          <InputNumber className="w-full!" min={0} precision={2} prefix="¥" placeholder="留空不出账单" />
        </Form.Item>
      </div>
    </section>
  )
}
